export default "__VITE_ASSET__4d458e75__"